<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/content/header/Header'
import Footer from '@/components/content/footer/Footer'
export default {
  name: "App",
  data() {
    return {
      activeColor: 'red'
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style>
  @import "assets/css/base.css";
</style>
